import React, {} from "react";
import "./Contact.css";
import { LayoutMain, MainHeadline, Contactform } from "../../components/common";
import "primeicons/primeicons.css";
import "../../components/common/contactForm/ContactForm.css";

const Contact = ({ headline = "Kontakt" }) => {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

  return (
    <LayoutMain>
      <div className="contact-page">
        <div className="background-container">
          <img src={`${baseImagePath}contact/background/contact.jpg`} alt="Background" className="background-image" />
        </div>
        <div className="content-wrapper">
          <MainHeadline text={headline} />
          <div className="contact">
            <div className="contact-col">
              <h3>Wir freuen uns auf deine Nachricht!</h3>
              <p>
                Bei Fragen, Wünschen oder anderen Anliegen, zögere nicht, dich
                bei uns zu melden. Wir erstellen dir gerne ein unverbindliches
                Angebot und beraten dich bei der Planung deiner perfekten
                Alpinreise. Ich freue mich darauf, dir bei der
                Verwirklichung deiner Reisepläne zur Seite zu stehen.
              </p>
              <ul>
                <li>
                  <i
                    className="pi pi-envelope"
                    style={{ marginRight: "16px" }}
                  ></i>
                  <a
                    href="mailto:info@kamikaze-travel.at"
                    className="text-dark"
                  >
                    info@kamikaze-travel.at
                  </a>
                </li>
                <li>
                  <i
                    className="pi pi-phone"
                    style={{ marginRight: "16px" }}
                  ></i>
                  <a href="tel:+4368181611886"
                  className="text-dark"
                  >
                    +43 681 816 118 86</a>
                </li>
                <li>
                  <i
                    className="pi pi-map-marker"
                    style={{ marginRight: "16px" }}
                  ></i>
                  Schiliftstraße 504, 5357 Saalbach-Hinterglemm
                </li>
              </ul>
            </div>
            <div className="contact-col">
            <Contactform showAddressFields={false} />
            </div>
          </div>
        </div>
      </div>
    </LayoutMain>
  );
};

export default Contact;
